import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { PUT_NON_NATIONAL_UPDATE_WITHDRAWAL_DETAILS_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';
import { PutWithdrawalDetailsRequestData } from '../../api/candidate/exam/model';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutNonNationalUpdateWithdrawalDetails = ({ uuid, onSuccess, onError }: Input) => {
  const putNonNationalUpdateWithdrawalDetails = async (data: PutWithdrawalDetailsRequestData) => {
    const res = await axiosClient.put<void>(
      PUT_NON_NATIONAL_UPDATE_WITHDRAWAL_DETAILS_URL(uuid),
      data.payload
    );
    return res.data;
  };

  return useCustomMutation(putNonNationalUpdateWithdrawalDetails, {
    onSuccess,
    onError,
  });
};
